import angular from 'angular';
import template from './uri.html';
import kformUtils from '../../utils/kform-utils';

const uriConfig = /* @ngInject */ (/** @type {any} */ KformComponentsProvider) => {
	KformComponentsProvider.register('uri', {
		title:      'URI',
		template,
		icon:       'fa fa-globe',
		controller: /* @ngInject */ (
			/** @type {any} */ $copyToClipboard,
			/** @type {import('angular').IFilterService} */ $filter,
			/** @type {any} */ $scope,
			/** @type {import('angular').translate.ITranslateService} */ $translate,
			/** @type {import('angular').IWindowService} */ $window,
		) => {
			$scope.uriRegex = /^([a-z][\d+.a-z-]*):(?:\/\/((?:(?=((?:[\w!$&'()*+,.:;=~-]|%[\da-f]{2})*))(\3)@)?(?=(\[[\d.:a-f]{2,}]|(?:[\w!$&'()*+,.;=~-]|%[\da-f]{2})*))\5(?::(?=(\d*))\6)?)(\/(?=((?:[\w!$&'()*+,./:;=@~-]|%[\da-f]{2})*))\8)?|(\/?(?!\/)(?=((?:[\w!$&'()*+,./:;=@~-]|%[\da-f]{2})*))\10)?)(?:\?(?=((?:[\w!$&'()*+,./:;=?@~-]|%[\da-f]{2})*))\11)?(?:#(?=((?:[\w!$&'()*+,./:;=?@~-]|%[\da-f]{2})*))\12)?$/i;

			if ($scope.options?.building) {
				return;
			}

			$scope.copyURI = () => {
				$copyToClipboard(
					$scope.data[$scope.component.key],
					true,
					(/** @type {string} */ v) => $filter('sprintf')(
						$translate.instant('common.x-copied-to-clipboard'),
						v,
					),
				);
			}

			$scope.changeValue = () => {
				if (typeof $scope.component.event.onChange === 'string') {
					const custom = ''.concat($scope.component.event.onChange, '; ');
					kformUtils.evaluate(custom, {
						data: $scope.data,
						form: $scope.form,
					});
				}
			};

			$scope.checkValue = () => $scope.uriRegex.test($scope.data[$scope.component.key]);

			$scope.openURI = () => $window.open($scope.data[$scope.component.key], '_blank');
		},
		children:   false,
		selectable: true,
		settings:   {
			autofocus:    false,
			disabled:     false,
			input:        true,
			tableView:    true,
			label:        'URI',
			key:          'uri',
			hideLabel:    false,
			placeholder:  '',
			prefix:       '',
			suffix:       '',
			defaultValue: '',
			protected:    false,
			persistent:   true,
			hidden:       false,
			clearOnHide:  true,
			validate:     {
				card:   '0-1',
				custom: '',
			},
			conditional:  {
				show: null,
				when: null,
				eq:   '',
			},
			event:        {
				onChange: null,
			},
			kdata: {
				submit: true,
			},
			displayCopyBtn: false,
		},
		views: [
			{
				name:     'Display',
				template: 'kform/components/uri/display.html',
			},
			{
				name:     'Data',
				template: 'kform/components/common/data.html',
			},
			{
				name:     'Validation',
				template: 'kform/components/uri/validate.html',
			},
			{
				name:     'API',
				template: 'kform/components/common/api.html',
			},
			{
				name:     'Layout',
				template: 'kform/components/common/layout.html',
			},
			{
				name:     'Conditional',
				template: 'kform/components/common/conditional.html',
			},
			{
				name:     'Events',
				template: 'kform/components/common/events.html',
			},
		],
	});
};

export default angular.module('app').config(uriConfig);
